import { KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { IAutocompleteOption } from 'core/types';
import { preventEnter } from 'core/utils';
import { AdvancedPartNumberFormField, ManufacturerFormField } from 'parts/elements';
import { IManufacturer, IPart } from 'parts/types';

interface IProps {
  onChangePartNumber: (part: Partial<IPart> & IAutocompleteOption) => void;
  onKeyDownPartNumber: (event: KeyboardEvent<HTMLInputElement>, value: string) => void;
  onChangeManufacturer: (manufacturer: IManufacturer) => void;
  isValidating: boolean;
  verifiedPart: boolean;
  isAlternateVersionEnabled: boolean;
}

export const PartSection = ({
  onChangePartNumber,
  onKeyDownPartNumber,
  onChangeManufacturer,
  isValidating,
  verifiedPart,
  isAlternateVersionEnabled,
}: IProps) => {
  const { t } = useTranslation();
  const { control, errors } = useFormContext();

  return (
    <>
      <AdvancedPartNumberFormField
        onChangePartNumber={onChangePartNumber}
        onKeyDownPartNumber={onKeyDownPartNumber}
        disabled={isValidating}
        isAlternateVersionEnabled={isAlternateVersionEnabled}
        level={1}
      />

      <ManufacturerFormField
        name="manufacturer"
        onChange={onChangeManufacturer}
        onBlur={onChangeManufacturer}
        disabled={verifiedPart || isValidating}
        isAlternateVersionEnabled={isAlternateVersionEnabled}
      />

      <FormField
        name="description"
        type={InputType.TEXTAREA}
        inputProps={{
          control: control,
          error: errors.description,
          label: t('labelDescription'),
          placeholder: t('placeholderUpsertLineDescription'),
          onKeyDown: preventEnter,
          maxRows: 6,
          disabled: verifiedPart || isValidating,
          required: true,
        }}
      />
    </>
  );
};
